import { Action } from '@ngrx/store';
import {
  SummaryCustomerAdvancePaymentListModel,
  SummaryCustomerAdvancePaymentModel
} from '../../models/summary-customer-advance-payment.model';

export enum CustomerAdvancePaymentActionTypes {
  Load = '[CustomerAdvancePayments] Load',
  LoadSuccess = '[CustomerAdvancePayments] Load Success',
  LoadFailure = '[CustomerAdvancePayments] Load Failure',
}

export class LoadCustomerAdvancePayments implements Action {
  readonly type = CustomerAdvancePaymentActionTypes.Load;
  constructor(public payload: { filter: any }) { }
}

export class LoadCustomerAdvancePaymentsSuccess implements Action {
  readonly type = CustomerAdvancePaymentActionTypes.LoadSuccess;
  constructor(public payload: {
    items: SummaryCustomerAdvancePaymentModel[];
    total: number;
    summary: SummaryCustomerAdvancePaymentListModel;
  }) { }
}

export class LoadCustomerAdvancePaymentsFailure implements Action {
  readonly type = CustomerAdvancePaymentActionTypes.LoadFailure;
  constructor(public payload: { error: any }) { }
}

export type CustomerAdvancePaymentActions =
  | LoadCustomerAdvancePayments
  | LoadCustomerAdvancePaymentsSuccess
  | LoadCustomerAdvancePaymentsFailure;
